import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  // Dialog styles
  dialogTitle: {
    margin: 0,
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '20px',
    paddingBottom: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #e0e0e0',
  },

  dialogContent: {
    padding: '24px !important',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  dialogPaper: {
    borderRadius: '8px',
    maxHeight: '70vh',
    display: 'flex',
    flexDirection: 'column',
  },

  dialogTitleText: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#24292f',
  },

  closeButton: {
    color: '#656d76',
    padding: '8px',
    ':hover': {
      backgroundColor: '#f6f8fa',
      color: '#24292f',
    },
  },

  // Banner styles
  infoBanner: {
    padding: '12px 16px 12px 16px',
    backgroundColor: '#dbeafe',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    marginBottom: '16px',
  },

  infoBannerContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },

  infoBannerIcon: {
    color: '#111827',
    fontSize: '20px',
    flexShrink: 0,
  },

  infoBannerText: {
    fontSize: '14px',
    color: '#111827',
    fontWeight: 600,
    fontStyle: 'semibold',
    marginBottom: '4px',
    lineHeight: '20px',
  },

  infoBannerBulletList: {
    fontSize: '14px',
    color: '#111827',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },

  infoBannerBullet: {
    fontSize: '14px',
    lineHeight: 1,
  },

  infoBannerSubText: {
    fontSize: '14px',
    color: '#111827',
    fontWeight: 400,
    marginBottom: '4px',
    lineHeight: '20px',
  },

  contextBanner: {
    padding: '13px 12px 13px 12px',
    borderRadius: '4px 4px 0 0 ',
    backgroundColor: '#f5f6f7',
    border: '1px solid #d1d5db',
  },

  contextBannerText: {
    fontSize: '14px',
    color: '#1e2635',
    fontWeight: 600,
    fontStyle: 'semibold',
  },

  // Table styles
  tableContainer: {
    minHeight: '200px',
    // maxHeight removed to allow table to fill available space
  },

  tableContainerScrollable: {
    overflowY: 'auto',
    flex: 1,
    minHeight: '300px',
  },
  tableContainerCollapsed: {
    overflowY: 'auto',
    flex: 1,
    minHeight: '200px', // Ensures modal doesn't shrink when collapsed
    maxHeight: '400px',
  },

  emptyState: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '128px',
  },

  emptyStateText: {
    color: '#6c757d',
  },

  // Row styles
  tableRow: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #d1d5db',
    minHeight: '52px',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    paddingTop: '12px',
    paddingBottom: '12px',
    fontSize: '13px',
    color: '#1E2635',
    fontWeight: 600,
    fontStyle: 'semibold',
    ':hover': {
      backgroundColor: '#eff6ff',
    },
  },

  tableRowSelected: {
    backgroundColor: '#eff6ff',
    ':hover': {
      backgroundColor: '#eff6ff',
    },
  },

  // Column styles
  expandColumn: {
    width: '40px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  expandButton: {
    padding: '4px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease',
    ':hover': {
      backgroundColor: '#f1f3f4',
    },
  },

  expandSpacer: {
    width: '24px',
  },

  iconColumn: {
    width: '40px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  folderIcon: {
    fontSize: '20px',
    color: '#666',
  },

  nameColumn: {
    flex: 1,
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },

  folderName: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1f2937',
  },

  currentFolderChip: {
    fontSize: '11px',
    fontStyle: 'semibold',
    fontWeight: 600,
    height: '20px',
    backgroundColor: '#E5E7EB',
    color: '#111827',
    borderRadius: '12px',
    padding: '0 8px',
    display: 'inline-flex',
    alignItems: 'center',
    float: 'right',
  },
  childrenCount: {
    fontSize: '11px',
    color: '#6c757d',
    fontWeight: 500,
    padding: '2px 8px',
    backgroundColor: '#f8f9fa',
    borderRadius: '10px',
    border: '1px solid #e9ecef',
  },

  // Footer styles
  dialogActions: {
    padding: '24px',
    gap: '16px',
    borderTop: '1px solid #e0e0e0',
  },

  cancelButton: {
    minWidth: '100px',
    height: '40px',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'none',
    borderColor: '#2563EB',
    color: '#2563EB',
    ':hover': {
      borderColor: '#2563EB',
      backgroundColor: '#eff6ff',
    },
  },

  confirmButton: {
    minWidth: '180px',
    height: '40px',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'none',
    backgroundColor: '#0969da',
    ':hover': {
      backgroundColor: '#0860ca',
    },
  },

  confirmButtonIcon: {
    fontSize: '16px',
    marginLeft: '4px',
  },

  tableContainerWithHeight: {
    overflowY: 'auto',
    flex: 1,
    minHeight: '30px', // The min height is set to 30px to align with one row's height; Setting this value too large then cause table's bottom's content hidden
    maxHeight: '500px',
    borderRadius: '0 0 4px 4px',
    border: '1px solid #d1d5db',
    borderTop: 'none',
  },

  loadingIndicator: {
    paddingLeft: '44px',
    paddingRight: '20px',
    paddingTop: '8px',
    paddingBottom: '8px',
    color: '#666',
    fontStyle: 'italic',
    textAlign: 'center',
  },

  subFolderLoadingIndicator: {
    paddingRight: '20px',
    paddingTop: '8px',
    paddingBottom: '8px',
    color: '#666',
    fontStyle: 'italic',
    borderBottom: '1px solid #d1d5db',
  },

  matterFolderRow: {
    paddingLeft: '20px',
    paddingRight: '20px',
  },

  matterFolderExpandColumn: {
    width: '40px',
    textAlign: 'center',
  },

  matterFolderIconColumn: {
    width: '40px',
    textAlign: 'center',
  },

  matterFolderNameColumn: {
    flex: 1,
    textAlign: 'left',
  },

  matterFolderChipSpacing: {
    marginLeft: '8px',
  },

  confirmButtonDisabled: {
    backgroundColor: '#8c959f !important',
    color: 'white !important',
  },

  // ViewMoreRow styles
  viewMoreRow: {
    backgroundColor: '#f5f6f7',
    borderBottom: '1px solid #e9ecef',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    ':hover': {
      backgroundColor: '#e9ecef',
    },
    ':focus': {
      backgroundColor: '#e9ecef',
      outline: '2px solid #0969da',
      outlineOffset: '-2px',
    },
  },

  viewMoreText: {
    fontSize: '14px',
    color: '#0969da',
    fontWeight: 500,
    textDecoration: 'underline',
    cursor: 'pointer',
    transition: 'color 0.2s ease',
  },

  loadingText: {
    color: '#6c757d',
    textDecoration: 'none',
    fontStyle: 'italic',
    fontWeight: 400,
  },

  viewMoreRowContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },

  viewMoreIconSpace: {
    width: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  viewMoreTextContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
  },
});
